var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerifiedTickV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#verified-tick_v2_svg__clip0_3302_422487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.711 5.667a3 3 0 001.622 1.625l2.576 1.066a3 3 0 011.623 3.92l-1.066 2.574a2.995 2.995 0 00.001 2.297l1.064 2.573a3 3 0 01-1.624 3.921l-2.574 1.067a3 3 0 00-1.624 1.621l-1.067 2.576a3 3 0 01-3.92 1.624l-2.574-1.066a3 3 0 00-2.295.001l-2.576 1.066a3 3 0 01-3.917-1.623l-1.067-2.576a3 3 0 00-1.622-1.625l-2.576-1.067a3 3 0 01-1.624-3.917l1.066-2.574a3 3 0 00-.002-2.296l-1.064-2.577a3 3 0 011.624-3.921L5.669 7.29a3 3 0 001.623-1.62L8.36 3.094a3 3 0 013.92-1.624l2.574 1.066a3 3 0 002.295-.001l2.577-1.063a3 3 0 013.919 1.623l1.067 2.577v-.005z",
    fill: "#0788F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.267 11.806a1.5 1.5 0 10-2.532-1.612l-5.874 9.23-2.689-3.36a1.5 1.5 0 00-2.343 1.874l4 5a1.5 1.5 0 002.438-.132l7-11z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "verified-tick_v2_svg__clip0_3302_422487"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgVerifiedTickV2;